import { removeSuperAdminToken, sortPermissions } from "../../common";
import { superAdminTokenName } from "../../config";

const getUserFromLocalStorage = () => {
  try {
    const admin = JSON.parse(sessionStorage.getItem(superAdminTokenName));
    if (admin && admin.authToken && admin.loggedInTime) {
      return admin;
    } else {
      removeSuperAdminToken();
      return null;
    }
  } catch (error) {
    removeSuperAdminToken();
    return null;
  }
};

const getInitial = () => {
  return getUserFromLocalStorage();
};

const adminReducer = (state = getInitial(), action) => {
  switch (action.type) {
    case "LOGIN_ADMIN":
      const { loggedInTime, authToken } = action.payload;
      const newState = {
        loggedInTime: loggedInTime || Date.now(),
        authToken: "Bearer " + authToken,
      };
      sessionStorage.setItem(superAdminTokenName, JSON.stringify(newState));
      return newState;

    case "LOGOUT_ADMIN":
      removeSuperAdminToken();
      return null;

    case "UPDATE_ADMIN_DASHBOARD":
      if (state) {
        state = {
          ...state,
          dashboard: {
            ...state.dashboard,
            ...action.payload,
          },
        };
      }
      return state;

    case "CLEAR_ADMIN_DASHBOARD":
      state.dashboard = null;
      return state;

    default:
      return state;
  }
};

export default adminReducer;
